import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import ServiceHeader from "../components/ServiceHeader";
import knowledge_img from "../static/img/team.png"; // Using an existing image
import "../static/css/About.css";

function KnowledgeBankPage() {
    return (
        <>
            <Nav />
            <ServiceHeader
                image={knowledge_img}
                title={"Knowledge Bank"}
                description={"A comprehensive resource for insolvency and bankruptcy knowledge."}
            />

            <div className="about-content" style={{ 
                minHeight: "500px", 
                display: "flex", 
                flexDirection: "column",
                justifyContent: "center", 
                alignItems: "center",
                background: "linear-gradient(to bottom, #ffffff, #f9f9f9)"
            }}>
                <div className="about-container" style={{ 
                    textAlign: "center",
                    padding: "60px",
                    borderRadius: "20px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                    background: "#fff"
                }}>
                    <h2 style={{ 
                        fontSize: "4rem", 
                        color: "#d4af37", 
                        marginBottom: "10px",
                        fontWeight: "800",
                        letterSpacing: "-1px"
                    }}>Coming Soon</h2>
                    <div style={{ 
                        width: "80px", 
                        height: "4px", 
                        background: "#d4af37", 
                        margin: "0 auto 30px" 
                    }}></div>
                    <p style={{ 
                        fontSize: "1.4rem", 
                        color: "#555",
                        maxWidth: "600px",
                        lineHeight: "1.6"
                    }}>
                        Our Knowledge Bank is being populated with comprehensive resources, 
                        expert insights, and regulatory updates. Check back soon!
                    </p>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default KnowledgeBankPage;
